/**
 * URL state persistence — encode scene state in query params so browser
 * refresh preserves the current view. Uses history.replaceState() to avoid
 * polluting browser history.
 */

export interface SceneUrlState {
  scene: string;
  [key: string]: string;
}

/** Read current URL params as a SceneUrlState (or null if no scene param). */
export function getUrlState(): SceneUrlState | null {
  const params = new URLSearchParams(window.location.search);
  const scene = params.get('scene');
  if (!scene) return null;

  const state: SceneUrlState = { scene };
  params.forEach((value, key) => {
    if (key !== 'scene') state[key] = value;
  });
  return state;
}

/** Write scene state to URL params via replaceState. */
export function setUrlState(state: SceneUrlState): void {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(state)) {
    params.set(key, value);
  }
  history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`);
}

/** Clear all scene-related URL params. */
export function clearUrlState(): void {
  history.replaceState(null, '', window.location.pathname);
}
